export default __webpack_public_path__ + "static/media/flat-ui.f108cdfe.svg";